export { default as getCurrentLazyDensity } from './getCurrentDensity';
